import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addPenalty, assignEmployeeByAdmin, getOrders } from "../../State/Order/Action";
import { DataGrid } from "@mui/x-data-grid";
import {
  Button,
  Card,
  CardHeader,
  Modal,
  Box,
  IconButton,
  Paper,
  Chip,
  TextField,
  Typography,
  CardContent,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AddCircle, Close, FileDownload, PictureAsPdf, Print, Visibility } from "@mui/icons-material";
import { jsPDF } from 'jspdf';
import { autoTable } from 'jspdf-autotable';
import dayjs from "dayjs";
import { PermissionService } from "../../../config/permissionService";
import { getSelectedExportRows } from "../../../config/exportSelection";
import { getAllEmployee } from "../../State/Employee/Action";
import ImagePopup from "../../../Common/ImagePopup";
import defaultImage from "../../../Common/productDefaultImage.png"

const Orders = () => {
  const dispatch = useDispatch();
  const { adminOrder, employees } = useSelector((store) => store);
  const [openDateHistoryModal, setOpenDateHistoryModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [openPenaltyDialog, setOpenPenaltyDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [penaltyValue, setPenaltyValue] = useState("");

  const [imageOpen, setImageOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");

  // Add this state for selection
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const handleOpenPenaltyDialog = (row) => {
    setSelectedRow(row);
    setPenaltyValue(row.panalty || "");
    setOpenPenaltyDialog(true);
  };

  const handleClosePenaltyDialog = () => {
    setOpenPenaltyDialog(false);
    setSelectedRow(null);
  };

  useEffect(() => {
    dispatch(getOrders());
    dispatch(getAllEmployee());
  }, [dispatch]);

  const [assignOpen, setAssignOpen] = useState(false);
  const [order, setOrder] = useState(null);
  const [empId, setEmpId] = useState("");

  const handleAssignEmployee = (orderId, empId) => {
    // 👉 yaha API call karo
    if (orderId && empId) {
      dispatch(assignEmployeeByAdmin(orderId, empId, setAssignOpen, setOrder, setEmpId));
    }
  };

  const getStatusChip = (status) => {
    const colorMap = {
      "PENDING": "warning",
      "PLACED": "dark",
      "SHIPPED": "info",
      "DELIVERED": "success",
      "CANCELLED": "error",
      "RETURNED": "error",
      "PICKED_UP": "dark",
      "COMPLETED": "success"
    };
    return <Chip label={status} color={colorMap[status] || "default"} variant="contained" sx={{ fontSize: "0.7rem", height: "24px", borderRadius: "12px", fontWeight: "bold" }} />;
  };

  const rows = adminOrder.orders?.response?.map((order, index) => ({
    id: order.id,
    orderId: order.orderId,
    orderDate: order.orderDate,
    userName: order.user?.name || "----",
    userEmail: order.user?.email || "----",
    userPhone: order.user?.phone || order.shippingAddress?.mobile || "----",
    userDetail: `${order.shippingAddress?.name || order.user?.name} (${order.user?.email ? `${order.user?.email}, ${order.shippingAddress?.mobile || order.user?.phone}` : order.shippingAddress?.mobile || order.user?.phone})` || "----",
    shippingAddress: `${order.shippingAddress?.addressLine1}, ${order.shippingAddress?.postOffice}, ${order.shippingAddress?.city}, ${order.shippingAddress?.state}, ${order.shippingAddress?.country}, ${order.shippingAddress?.zipcode}, ${order.shippingAddress?.mobile}`,
    employeeName: order.employee?.name || "----",
    employeeEmail: order.employee?.email || "----",
    employeePhone: order.employee?.phone || "----",
    employeeDetail: order?.employee ? `${order.employee?.name} (${order.employee?.email}, ${order.employee?.phone})` : "----",
    vendorName: order?.orderItems?.map((item) => item?.product?.vendor?.name).join(", ") || "----",
    vendorEmail: order?.orderItems?.map((item) => item?.product?.vendor?.email).join(", ") || "----",
    vendorPhone: order?.orderItems?.map((item) => item?.product?.vendor?.phone).join(", ") || "----",
    vendorDetails: order?.orderItems?.map((item) => `${item?.product?.vendor?.name} (${item?.product?.vendor?.email}, ${item?.product?.vendor?.phone})`).join(", ") || "----",
    pickingAddress: order?.orderItems?.map((item) => `(${item?.product?.vendor?.fullAddress})`).join(", ") || "----",
    productImages: order?.orderItems
      ?.flatMap((item) =>
        (item?.product?.images || [])
          .filter((img) => img.isPrimary)
          .map((img) => img.fullUrl)
      )
      ?.filter(Boolean)
      ?.join(",") || "----",
    productTitles: order.orderItems?.map((item) => item.product?.title).join(", ") || "----",
    productNames: order.orderItems?.map((item) => item.product?.productCategory?.name).join(", ") || "----",
    quantity: order?.orderItems?.map((item) => item?.quantity).join(", ") || 0,
    adminPrice: order?.orderItems?.map((item) => item?.variant?.adminPrice?.toFixed(2)).join(", ") || 0,
    size: order?.orderItems?.map((item) => item?.size).join(", ") || "----",
    color: order?.orderItems?.map((item) => item?.color).join(", ") || "----",
    totalQuantity: order.totalItem || 0,
    vendorTotalPrice: order?.orderItems?.reduce(
      (sum, item) => sum + ((item?.variant?.vendorPrice || 0.00) * (item?.quantity || 0)),
      0
    ).toFixed(2),
    adminTotalPrice: order?.orderItems?.reduce((sum, item) => sum + (item?.variant?.adminPrice?.toFixed(2) * item?.quantity || 0), 0) || 0,
    customerTotalPrice: order?.orderTotalPrice?.toFixed(2) || 0,
    totalAdminPrice: order.totalPrice?.toFixed(2) || 0,
    deliveryDate: order?.deliveryDate,
    dispatchDate: order?.dispatchDate,
    orderStatus: order.orderStatus,
    penaltyPrice: order.penaltyPrice?.toFixed(2) || 0,
    cancelReturnDate: order.cancelDate ? dayjs(order.cancelDate).format("DD MMM YYYY") : order.returnDate ? dayjs(order.returnDate).format("DD MMM YYYY") : "----",
    cancelReturnReason: order.cancelRegion || order?.returnReason || "----",
    returnImages: order?.imageUrls,
    currencyCode: order?.currencyCode || "----",
    shippingCountry: order?.shippingAddress?.country || "----",
    deliveryAddress: order?.shippingAddress,
    currencyRate: order?.currencyRate || "----",
    deliveryDateHistories: order.deliveryDateHistories,
  })) || [];

  const filteredRows = rows.filter((row) => {
    const query = searchText.toLowerCase();
    return (
      row.orderId.toLowerCase().includes(query) ||
      row.userName.toLowerCase().includes(query) ||
      row.userEmail.toLowerCase().includes(query) ||
      row.userPhone.toLowerCase().includes(query) ||
      row.shippingAddress.toLowerCase().includes(query) ||
      row.employeeName.toLowerCase().includes(query) ||
      row.employeeEmail.toLowerCase().includes(query) ||
      row.employeePhone.toLowerCase().includes(query) ||
      row.vendorName.toLowerCase().includes(query) ||
      row.vendorEmail.toLowerCase().includes(query) ||
      row.vendorPhone.toLowerCase().includes(query) ||
      row.productTitles.toLowerCase().includes(query) ||
      row.productNames.toLowerCase().includes(query) ||
      String(row.quantity).toLowerCase().includes(query) ||
      String(row.adminPrice).toLowerCase().includes(query) ||
      row.size.toLowerCase().includes(query) ||
      row.color.toLowerCase().includes(query) ||
      row.currencyCode.toLowerCase().includes(query) ||
      String(row.totalQuantity).toLowerCase().includes(query) ||
      String(row.adminTotalPrice).toLowerCase().includes(query) ||
      String(row.vendorTotalPrice).toLowerCase().includes(query) ||
      String(row.customerTotalPrice).toLowerCase().includes(query) ||
      String(row.totalAdminPrice).toLowerCase().includes(query) ||
      String(row.currencyRate).toLowerCase().includes(query) ||
      row.orderStatus.toLowerCase().includes(query)
    );
  });
  const getExportData = () => getSelectedExportRows(filteredRows, selectedRowIds);


  const handleExportCSV = () => {
    const exportRows = getExportData();
    if (!exportRows) return;
    const csvContent = exportRows.map((row, index) => {
      return [
        index + 1,
        row.orderId,
        row.orderDate ? dayjs(row.orderDate).format("DD MMM YYYY") : "----",
        row.userDetail,
        `"${row.shippingAddress}"`,
        row.employeeDetail,
        row.vendorDetails,
        `"${row.productTitles}"`,
        `"${row.productNames}"`,
        row.size,
        row.color,
        row.totalQuantity,
        row.vendorTotalPrice,
        row.customerTotalPrice,
        row.deliveryDate ? dayjs(row.deliveryDate).format("DD MMM YYYY") : "----",
        row.orderStatus,
        row.cancelDate ? dayjs(row.cancelDate).format("DD MMM YYYY") : "----",
        row.cancelRegion,
        row.penaltyPrice
      ].join(',');
    }).join('\n');

    const headers = [
      'S.No.',
      'Order ID',
      'Order Date',
      'Customer Detail',
      'Shipping Address',
      'Employee Detail',
      'Vendor Details',
      'Product Titles',
      'Product Names',
      'Size',
      'Color',
      'Total Quantity',
      'Total Vendor Price',
      'Total Customer Price',
      'Delivery Date',
      'Order Status',
      'Cancel Date',
      'Cancel Reason',
      'Penalty Price',
    ].join(',');

    const csv = `${headers}\n${csvContent}`;
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'orders.csv';
    link.click();
  };
  const handleExportPDF = () => {
    const exportRows = getExportData();
    if (!exportRows) return;
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "pt",
      format: "a2", // even larger than A3 to fit all columns
    });

    doc.setFontSize(18);
    doc.text("Order List", 40, 30);

    const tableColumn = [
      'S.No.', 'Order ID', 'Order Date', 'Customer Detail', 'Shipping Address',
      'Employee Detail',
      'Vendor Details',
      'Product Titles', 'Product Names',
      'Size', 'Color',
      'Total Quantity', 'Total Vendor Price', 'Total Customer Price',
      'Delivery Date', 'Order Status', 'Cancel Date', 'Cancel Reason', 'Penalty Price'
    ];

    const tableRows = exportRows.map((row, index) => ([
      index + 1,
      row.orderId,
      row.orderDate ? dayjs(row.orderDate).format("DD MMM YYYY HH:mm") : "----",
      row.userDetail,
      row.shippingAddress,
      row.employeeDetail,
      row.vendorDetails,
      row.productTitles,
      row.productNames,
      row.size,
      row.color,
      row.totalQuantity,
      row.vendorTotalPrice,
      row.customerTotalPrice,
      row.deliveryDate ? dayjs(row.deliveryDate).format("DD MMM YYYY") : "----",
      row.orderStatus,
      row.cancelDate ? dayjs(row.cancelDate).format("DD MMM YYYY") : "----",
      row.cancelRegion,
      row.penaltyPrice
    ]));

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 50,
      styles: {
        fontSize: 8,
        cellPadding: 3,
        overflow: 'linebreak',
        valign: 'top',
      },
      columnStyles: {
        4: { cellWidth: 100 },   // Shipping Address
        7: { cellWidth: 100 },  // Product Titles
        8: { cellWidth: 100 },  // Product Names
      },
      headStyles: {
        fillColor: [37, 99, 235], // Tailwind blue-600 (RGB: 37,99,235)
        textColor: [255, 255, 255], // white text
        halign: 'left',
      },
      bodyStyles: {
        halign: 'left'
      },
      margin: { top: 50, left: 10, right: 10, bottom: 20 },
      didDrawPage: (data) => {
        doc.setFontSize(10);
        doc.text(`Generated on: ${new Date().toLocaleString()}`, 10, doc.internal.pageSize.height - 10);
      },
    });

    doc.save("orders.pdf");
  };

  const writeAction = PermissionService.has({ category: "Admin", page: "Orders", type: "WRITE" });

  const columns = [
    {
      field: "serialNo",
      headerName: "S.No.",
      width: 80,
      sortable: false,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1
    },
    { field: "orderId", headerName: "Order ID", width: 100 },
    { field: "orderDate", headerName: "Order Date", width: 120, renderCell: (params) => params.value ? dayjs(params?.value).format("DD MMM YYYY HH:mm") : "----" },
    { field: "userDetail", headerName: "Customer Detail", width: 150 },
    { field: "shippingAddress", headerName: "Shipping Address", width: 150 },
    { field: "employeeDetail", headerName: "Employee Detail", width: 150 },
    { field: "vendorDetails", headerName: "Vendor Details", width: 150 },
    { field: "pickingAddress", headerName: "Picking Address", width: 150 },
    { field: "dispatchDate", headerName: "Dispatch Date", width: 120, renderCell: (params) => params.value ? dayjs(params?.value).format("DD MMM YYYY") : "----" },
    {
      field: "productImages",
      headerName: "Image(s)",
      width: 100,
      renderCell: (params) => {
        const images = params?.value
          ? params.value.split(",").map((url) => url.trim()) // multiple comma separated
          : [];

        if (images.length === 0) {
          return <span>----</span>;
        }

        return (
          <div style={{ display: "flex", gap: "5px" }}>
            {images.map((url, index) => (
              <img
                key={index}
                onClick={() => {
                  setImageOpen(true);
                  setImageUrl(url || defaultImage);
                }}
                src={url || defaultImage}
                alt={`order_image_${index}`}
                width={30}
                height={30}
                style={{ borderRadius: 8, objectFit: "cover", cursor: "pointer" }}
              />
            ))}
          </div>
        );
      },
    },
    { field: "productTitles", headerName: "Product Titles", width: 150 },
    { field: "color", headerName: "Colors", width: 120 },
    { field: "size", headerName: "Sizes", width: 120 },
    { field: "totalQuantity", headerName: "Quantity", width: 80 },
    { field: "vendorTotalPrice", headerName: "Vendor Total Price", width: 100 },
    { field: "customerTotalPrice", headerName: "Customer Total Price", width: 100 },
    { field: "deliveryDate", headerName: "Delivery Date", width: 120, renderCell: (params) => params.value ? dayjs(params?.value).format("DD MMM YYYY") : "----" },
    {
      field: "orderStatus",
      headerName: "Status",
      width: 180,
      renderCell: (params) => {
        const isINRIndia =
          params?.row?.currencyCode !== "INR" &&
          params?.row?.shippingCountry !== "India" && params?.row?.employee === null;

        if (isINRIndia) {
          return (
            <Button
              variant="contained"
              onClick={() => {
                setOrder(params?.row); // row save
                setAssignOpen(true); // popup open

              }}
              sx={{
                background: "linear-gradient(90deg, #449AEF 0%, #f87171 100%)",
                color: "#fff",
                fontWeight: 600,
                fontSize: "0.75rem",
                borderRadius: "6px",
                boxShadow: "0 2px 8px rgba(34,197,94,0.15)",
                px: 2,
                py: 0.4,
                transition: "all 0.2s",
                "&:hover": {
                  background: "linear-gradient(90deg, #f87171 0%, #449AEF 100%)",
                  boxShadow: "0 4px 16px rgba(34,197,94,0.25)",
                  transform: "scale(1.02)",
                },
                minWidth: 'auto',
              }}
            >
              Assign Employee
            </Button>
          );
        }
        return getStatusChip(params.value);
      },
    },
    { field: "currencyCode", headerName: "Currency Code", width: 80 },
    { field: "currencyRate", headerName: "Exchange Rate", width: 80 },
    { field: "cancelReturnDate", headerName: "Cancel/Return Date", width: 100, },
    { field: "cancelReturnReason", headerName: "Cancel/Return Reason", width: 100 },
    {
      field: "returnImages",
      headerName: "Return Image(s)",
      width: 100,
      renderCell: (params) => {
        const images = params?.value

        if (images.length === 0) {
          return <span>----</span>;
        }

        return (
          <div style={{ display: "flex", gap: "5px" }}>
            {images.map((url, index) => (
              <img
                key={index}
                onClick={() => {
                  setImageOpen(true);
                  setImageUrl(url || defaultImage);
                }}
                src={url || defaultImage}
                alt={`return_image_${index}`}
                width={30}
                height={30}
                style={{ borderRadius: 8, objectFit: "cover", cursor: "pointer" }}
              />
            ))}
          </div>
        );
      },
    },
    {
      field: "penaltyPrice",
      headerName: "Penalty Price",
      width: 100,
      renderCell: (params) => {
        const row = params.row;
        const histories = row?.deliveryDateHistories || [];

        // Default: no rescheduling, so show penalty
        let showPenalty = histories.length === 0;

        // If rescheduled, check if it's delivered earlier
        if (histories.length > 0) {
          const first = histories[0];
          const newDate = new Date(first?.newDeliveryDate);
          const oldDate = new Date(first?.oldDeliveryDate);

          // If early delivery → show penalty
          if (newDate < oldDate) {
            showPenalty = true;
          } else if (params.value) {
            showPenalty = true;
          } else {
            showPenalty = false;
          }
        }

        return (
          <Box display="flex" alignItems="center" gap={0.5} pt={0} sx={{ padding: 0, minHeight: 0 }}>
            {showPenalty ? (
              <Typography variant="body2" sx={{ fontSize: "0.8rem", p: 0, m: 0 }}>
                {row.penaltyPrice || "----"}
              </Typography>
            ) : (
              !params.value && writeAction && <AddCircle
                fontSize="small"
                color="primary"
                sx={{ cursor: "pointer", fontSize: 16, p: 0, m: 0 }}
                onClick={() => handleOpenPenaltyDialog(row)}
              />
            )}
          </Box>
        );
      }
    }
    ,
    {
      field: "history",
      headerName: "History",
      width: 80,
      renderCell: (params) => (
        <Tooltip title="View History">
          <IconButton
            size="small"
            sx={{ p: 0, m: 0, minWidth: 24, minHeight: 24, cursor: "pointer" }}
            onClick={() => {
              setOpenDateHistoryModal(true);
              setSelectedOrder(params.row);
            }}
          >
            <Visibility fontSize="small" sx={{ fontSize: 15, cursor: "pointer" }} />
          </IconButton>
        </Tooltip>
      )
    }
  ];


  const excludedFields = ['serialNo', 'history']; // Add more fields if needed

  const exportableColumns = columns.filter(col => !excludedFields.includes(col.field));
  // Get headers from column definitions
  const headers = exportableColumns.map(col => col.headerName);
  const csvFields = exportableColumns.map(col => col.field);

  const handlePrint = () => {
    const exportRows = getExportData();
    if (!exportRows) return;
    const printWindow = window.open('', '_blank');
    const data = exportRows.map(row =>
      csvFields.map(field => row[field] ?? "----")
    );

    const html = `
      <html>
        <head>
          <title>Order List</title>
          <style>
            @media print {
              @page { size: A3 landscape; }
            }
            body {
              font-family: Arial, sans-serif;
              font-size: 12px;
            }
            table {
              border-collapse: collapse;
              width: 100%;
              table-layout: auto;
            }
            th, td {
              border: 1px solid #999;
              padding: 4px;
              text-align: left;
              white-space: pre-wrap;
              word-break: break-word;
            }
            th {
             background: #449AEF;
                color: white;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
            tr:nth-child(even) {
              background: #f5f5f5;
            }
          </style>
        </head>
        <body>
          <h2>Order List</h2>
          <table>
            <thead>
              <tr>${headers.map(h => `<th>${h}</th>`).join('')}</tr>
            </thead>
            <tbody>
              ${data.map(row => `<tr>${row.map(cell => `<td>${cell}</td>`).join('')}</tr>`).join('')}
            </tbody>
          </table>
        </body>
      </html>
    `;

    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
      }, 300);
    };
  };

  return (
    <div>
      <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
        <CardHeader
          title={
            <Typography variant="h6" className="text-gray-700">
              ORDERS
            </Typography>
          }
        />
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', mb: 2 }}>
            <Box sx={{ display: 'flex', gap: 1.5, mb: { xs: 2, sm: 0 } }}>
              <Button
                variant="contained"
                startIcon={<FileDownload />}
                onClick={handleExportCSV}
                sx={{
                  background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '0.85rem',
                  borderRadius: '6px',
                  px: 2,
                  py: 0.8,
                  transition: 'all 0.2s',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                    boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                    transform: 'scale(1.02)',
                  },
                  cursor: 'pointer',
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                Export CSV
              </Button>
              <Button
                variant="contained"
                startIcon={<PictureAsPdf />}
                onClick={handleExportPDF}
                sx={{
                  background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '0.85rem',
                  borderRadius: '6px',
                  px: 2,
                  py: 0.8,
                  transition: 'all 0.2s',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                    boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                    transform: 'scale(1.02)',
                  },
                  cursor: 'pointer',
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                Export PDF
              </Button>
              <Button
                variant="contained"
                startIcon={<Print />}
                onClick={handlePrint}
                sx={{
                  background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '0.85rem',
                  borderRadius: '6px',
                  px: 2,
                  py: 0.8,
                  transition: 'all 0.2s',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                    boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                    transform: 'scale(1.02)',
                  },
                  cursor: 'pointer',
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                Print
              </Button>
            </Box>
            <Box>
              <TextField
                label="Search Orders"
                variant="outlined"
                size="small"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{ width: { xs: '100%', sm: '300px' } }}
              />
            </Box>
          </Box>
          <Box sx={{ height: "100%", width: "100%" }}>
            <DataGrid
              rows={filteredRows}
              columns={columns}
              pagination
              initialState={{
                pagination: { paginationModel: { pageSize: 10, page: 0 } },
              }}
              pageSizeOptions={[10, 25, 50, 75, 100]}
              getRowId={(row) => row.id}
              checkboxSelection
              onRowSelectionModelChange={(ids) => setSelectedRowIds(ids)}
              rowSelectionModel={selectedRowIds}
              disableSelectionOnClick
              density="compact"
              experimentalFeatures={{ virtualization: true }}
              loading={adminOrder.loading}
              autoHeight={true}
              sx={{
                borderRadius: 2,
                fontSize: "0.8rem",
                "& .MuiDataGrid-cell": {
                  fontSize: "0.8rem",
                  border: "1px solid rgb(204, 201, 201)",
                  minHeight: "36px !important",
                  height: "36px !important",
                  lineHeight: "1.2",
                  paddingTop: "4px",
                  paddingBottom: "4px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                },
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "#449AEF",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "0.8rem",
                  border: "1px solid rgb(204, 201, 201)",
                  minHeight: "36px !important",
                  height: "36px !important",
                  lineHeight: "1.2",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontSize: "0.8rem",
                  fontWeight: 600,
                },
                "& .MuiDataGrid-row": {
                  maxHeight: "36px !important",
                  minHeight: "36px !important",
                },
                "& .MuiDataGrid-row:nth-of-type(odd)": {
                  backgroundColor: "#f5f5f5",
                },
                "& .MuiDataGrid-row:nth-of-type(even)": {
                  backgroundColor: "#ffffff",
                },
                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            />
          </Box>
        </CardContent>
      </Card>

      <Modal
        open={openDateHistoryModal}
        onClose={() => setOpenDateHistoryModal(false)}
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: '12px',
          boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
          p: 3,
          width: { xs: '95%', sm: '80%', md: '70%' },
          maxWidth: '800px',
          maxHeight: '90vh',
          overflow: 'auto',
          fontSize: "0.8rem",
        }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} pb={1} sx={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: "1.1rem" }}>
              Date History
            </Typography>
            <IconButton onClick={() => setOpenDateHistoryModal(false)} size="small">
              <CloseIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Box>
          <Paper sx={{ height: 300, width: "100%", boxShadow: 0, borderRadius: 0 }}>
            <DataGrid
              rows={
                selectedOrder?.deliveryDateHistories?.map((history, index) => ({
                  id: index,
                  oldDate: history.oldDeliveryDate,
                  newDate: history.newDeliveryDate,
                  reason: history.region
                })) || []
              }
              columns={[
                {
                  field: "serialNo",
                  headerName: "S.No.",
                  flex: 1,
                  sortable: false,
                  renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1
                },
                { field: "oldDate", headerName: "Old Date", flex: 1, renderCell: (params) => params.value ? dayjs(params?.value).format("DD MMM YYYY") : "----" },
                { field: "newDate", headerName: "New Date", flex: 1, renderCell: (params) => params.value ? dayjs(params?.value).format("DD MMM YYYY") : "----" },
                { field: "reason", headerName: "Reason", flex: 2 },
              ]}
              pagination
              initialState={{
                pagination: { paginationModel: { pageSize: 5, page: 0 } },
              }}
              pageSizeOptions={[5, 10, 15]}
              disableSelectionOnClick
              density="compact"
              experimentalFeatures={{ virtualization: true }}
              loading={adminOrder.loading}
              autoHeight={true}
              sx={{
                borderRadius: 2,
                fontSize: "0.8rem",
                "& .MuiDataGrid-cell": {
                  fontSize: "0.8rem",
                  border: "1px solid rgb(204, 201, 201)",
                  minHeight: "36px !important",
                  height: "36px !important",
                  lineHeight: "1.2",
                  paddingTop: "4px",
                  paddingBottom: "4px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                },
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "#449AEF",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "0.8rem",
                  border: "1px solid rgb(204, 201, 201)",
                  minHeight: "36px !important",
                  height: "36px !important",
                  lineHeight: "1.2",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontSize: "0.8rem",
                  fontWeight: 600,
                },
                "& .MuiDataGrid-row": {
                  maxHeight: "36px !important",
                  minHeight: "36px !important",
                },
                "& .MuiDataGrid-row:nth-of-type(odd)": {
                  backgroundColor: "#f5f5f5",
                },
                "& .MuiDataGrid-row:nth-of-type(even)": {
                  backgroundColor: "#ffffff",
                },
                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            />
          </Paper>
        </Box>
      </Modal>

      {/* add penalty dialog box */}
      <Dialog
        open={openPenaltyDialog}
        onClose={handleClosePenaltyDialog}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 2, p: 1 },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "1rem",
            fontWeight: "bold",
          }}
        >
          Set Penalty Price
          <IconButton onClick={handleClosePenaltyDialog}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <TextField
            label="Penalty Price"
            fullWidth
            size="small"
            type="number"
            value={penaltyValue}
            onChange={(e) => setPenaltyValue(e.target.value)}
            inputProps={{ maxLength: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePenaltyDialog} color="inherit">
            Cancel
          </Button>
          <Button variant="contained" color="primary" disabled={penaltyValue === 0 && penaltyValue === ""} onClick={() => {
            dispatch(addPenalty(selectedRow.id, penaltyValue))
            handleClosePenaltyDialog();
          }}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={assignOpen} onClose={() => {
        setAssignOpen(false)
        setEmpId("");
        setOrder(null)
      }} maxWidth="sm" fullWidth>
        <DialogTitle
          sx={{
            position: "sticky",
            top: 0,
            backgroundColor: "white",
            zIndex: 1,
            borderBottom: "1px solid #eee",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          Assign Employee
          <IconButton
            edge="end"
            onClick={() => {
              setAssignOpen(false)
              setEmpId("");
              setOrder(null)
            }}
            sx={{ color: "grey.600" }}
            aria-label="close"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {/* Shipping Address Card */}
          <Card variant="outlined" sx={{ mb: 2, mt: 2, borderRadius: 2, boxShadow: 1 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Shipping Address
              </Typography>
              <Typography variant="body2">
                {order?.deliveryAddress?.name}
              </Typography>
              <Typography variant="body2">
                {order?.deliveryAddress?.addressLine1},{" "}
                {order?.deliveryAddress?.addressLine2}
              </Typography>
              <Typography variant="body2">
                {order?.deliveryAddress?.city}, {order?.deliveryAddress?.state} -{" "}
                {order?.deliveryAddress?.zipcode}
              </Typography>
              <Typography variant="body2">
                {order?.deliveryAddress?.country}
              </Typography>
              <Typography variant="body2">
                📞 {order?.deliveryAddress?.mobile}
              </Typography>
            </CardContent>
          </Card>

          {/* Employee Dropdown */}
          <FormControl fullWidth>
            <InputLabel>Select Employee</InputLabel>
            <Select
              value={empId}
              onChange={(e) => setEmpId(e.target.value)}
              label="Select Employee"
            >
              {employees?.employees?.response?.filter(e => e.enabled)?.map((emp) => (
                <MenuItem key={emp.id} value={emp.id}>
                  {emp.name} ({emp.email}, {emp.phone}) - {emp.masterPincode.regionName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        {/* Footer Fixed - Center Button */}
        <DialogActions
          sx={{
            justifyContent: "center",
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
            borderTop: "1px solid #eee",
            py: 2,
          }}
        >
          <Button
            onClick={() => {
              handleAssignEmployee(order?.id, empId)
            }}
            color="primary"
            variant="contained"
            disabled={!empId}
          >
            {adminOrder.loading ? (
              <>
                <CircularProgress size={20} color="white" sx={{ mr: 1 }} />
                Processing...
              </>
            ) : "Assign"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Common Popup */}
      <ImagePopup
        open={imageOpen}
        onClose={() => setImageOpen(false)}
        imageUrl={imageUrl}
      />

    </div>
  );
};

export default Orders;
